export const CoinIcon = ({ className }: { className: string }) => {
  return (
    <svg className={className} viewBox='0 0 27 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_42435_4605)'>
        <path
          d='M22.3945 26.1606C27.5175 20.9568 27.5175 12.5198 22.3945 7.31595C17.2715 2.11215 8.96544 2.11215 3.84243 7.31595C-1.28057 12.5198 -1.28057 20.9568 3.84243 26.1606C8.96544 31.3644 17.2715 31.3644 22.3945 26.1606Z'
          fill='#FCAB28'
        />
        <path
          d='M0 16.7383C0 17.463 0.0579869 18.1743 0.167658 18.8683C2.0724 19.9625 4.27275 20.588 6.61681 20.588C13.862 20.588 19.7351 14.6223 19.7351 7.26281C19.7351 6.53743 19.6771 5.82613 19.5674 5.13275C17.6627 4.03859 15.4623 3.41309 13.1183 3.41309C5.87307 3.41245 0 9.37878 0 16.7383Z'
          fill='#FFCE45'
        />
        <path
          d='M13.118 26.395C7.87589 26.395 3.61133 22.0632 3.61133 16.7383C3.61133 11.4135 7.87589 7.08105 13.118 7.08105C18.3602 7.08105 22.6247 11.4129 22.6247 16.7377C22.6247 22.0625 18.3602 26.3943 13.118 26.3943V26.395ZM13.118 7.40629C8.05237 7.40629 3.93089 11.5928 3.93089 16.7383C3.93089 21.8839 8.05237 26.0704 13.118 26.0704C18.1837 26.0704 22.3052 21.8839 22.3052 16.7383C22.3052 11.5928 18.1837 7.40629 13.118 7.40629Z'
          fill='#FCAB28'
        />
        <path
          d='M2.96179 11.3758C2.96179 11.3758 1.9218 9.18172 4.16186 8.12598C4.16186 8.12598 4.32196 10.4014 2.96179 11.3758Z'
          fill='#FFE266'
        />
        <path
          d='M3.04104 12.2697C3.04104 12.2697 2.88095 10.6448 5.44057 10.2383C5.44057 10.2383 5.04033 11.7819 3.04104 12.2697Z'
          fill='#FFE266'
        />
        <path
          d='M4.82401 9.00009C4.82401 9.00009 4.25612 6.63442 6.66257 6.07422C6.66257 6.07422 6.35373 8.3336 4.82401 9.00009Z'
          fill='#FFE266'
        />
        <path
          d='M4.71875 9.89056C4.71875 9.89056 4.8946 8.26693 7.48195 8.41034C7.48195 8.41034 6.77476 9.83614 4.71875 9.89056Z'
          fill='#FFE266'
        />
        <path
          d='M6.99696 7.10266C6.99696 7.10266 6.88036 4.67042 9.34859 4.58398C9.34859 4.58398 8.62375 6.74285 6.99696 7.10266Z'
          fill='#FFE266'
        />
        <path
          d='M6.72852 7.95777C6.72852 7.95777 7.20439 6.39752 9.71736 7.03648C9.71736 7.03648 8.7568 8.3003 6.72852 7.95777Z'
          fill='#FFE266'
        />
        <path
          d='M9.4375 5.65097C9.4375 5.65097 10.0363 3.29299 12.4182 3.95372C12.4182 3.95372 11.0958 5.79695 9.4375 5.65097Z'
          fill='#FFE266'
        />
        <path
          d='M8.92969 6.38633C8.92969 6.38633 9.8392 5.03991 12.0534 6.40681C12.0534 6.40681 10.7676 7.32427 8.92969 6.38633Z'
          fill='#FFE266'
        />
        <path
          d='M12.2617 5.06936C12.2617 5.06936 13.5349 3.00652 15.6086 4.3683C15.6086 4.3683 13.799 5.71855 12.2617 5.06936Z'
          fill='#FFE266'
        />
        <path
          d='M11.5605 5.61431C11.5605 5.61431 12.8287 4.61042 14.5317 6.59451C14.5317 6.59451 13.0329 7.0734 11.5605 5.61431Z'
          fill='#FFE266'
        />
        <path
          d='M15.2227 5.30659C15.2227 5.30659 17.0215 3.69768 18.6275 5.60302C18.6275 5.60302 16.5141 6.37322 15.2227 5.30659Z'
          fill='#FFE266'
        />
        <path
          d='M14.3965 5.62609C14.3965 5.62609 15.8941 5.03131 16.97 7.42515C16.97 7.42515 15.3986 7.45076 14.3965 5.62609Z'
          fill='#FFE266'
        />
        <path
          d='M17.9766 6.48712C17.9766 6.48712 20.0654 5.29308 21.2465 7.49612C21.2465 7.49612 19.0216 7.80344 17.9766 6.48712Z'
          fill='#FFE266'
        />
        <path
          d='M17.1035 6.62597C17.1035 6.62597 18.69 6.36027 19.2522 8.92889C19.2522 8.92889 17.7099 8.62222 17.1035 6.62597Z'
          fill='#FFE266'
        />
        <path
          d='M20.3652 8.10073C20.3652 8.10073 22.6393 7.33053 23.3875 9.72052C23.3875 9.72052 21.1455 9.59375 20.3652 8.10073Z'
          fill='#FFE266'
        />
        <path
          d='M19.4824 8.06934C19.4824 8.06934 21.0897 8.11351 21.1628 10.7442C21.1628 10.7442 19.7055 10.1463 19.4824 8.06934Z'
          fill='#FFE266'
        />
        <path
          d='M22.3965 10.0948C22.3965 10.0948 24.7929 10.0442 24.8099 12.5527C24.8099 12.5527 22.706 11.7562 22.3965 10.0948Z'
          fill='#FFE266'
        />
        <path
          d='M21.5626 9.79785C21.5626 9.79785 23.0848 10.3241 22.3864 12.8588C22.3864 12.8588 21.1693 11.8485 21.5626 9.79785Z'
          fill='#FFE266'
        />
        <path
          d='M23.7112 12.7002C23.7112 12.7002 26.0105 13.3891 25.2787 15.7842C25.2787 15.7842 23.5107 14.3782 23.7112 12.7002Z'
          fill='#FFE266'
        />
        <path
          d='M23.005 12.1611C23.005 12.1611 24.2984 13.1311 22.8777 15.3316C22.8777 15.3316 22.0192 13.9948 23.005 12.1611Z'
          fill='#FFE266'
        />
        <path
          d='M24.4861 15.4883C24.4861 15.4883 26.52 16.7771 25.1838 18.886C25.1838 18.886 23.8507 17.0505 24.4861 15.4883Z'
          fill='#FFE266'
        />
        <path
          d='M23.9496 14.7773C23.9496 14.7773 24.9404 16.0636 22.9916 17.7973C22.9916 17.7973 22.5163 16.2755 23.9496 14.7773Z'
          fill='#FFE266'
        />
        <path
          d='M24.1681 18.5078C24.1681 18.5078 25.8938 20.198 24.1548 21.9792C24.1548 21.9792 23.2264 19.9022 24.1681 18.5078Z'
          fill='#FFE266'
        />
        <path
          d='M23.787 17.6973C23.787 17.6973 24.4929 19.1647 22.2321 20.449C22.2321 20.449 22.0789 18.8599 23.787 17.6973Z'
          fill='#FFE266'
        />
        <path
          d='M23.3289 21.2939C23.3289 21.2939 24.708 23.2857 22.6683 24.6993C22.6683 24.6993 22.1439 22.4816 23.3289 21.2939Z'
          fill='#FFE266'
        />
        <path
          d='M23.1067 20.4248C23.1067 20.4248 23.5264 22.0017 21.0664 22.8276C21.0664 22.8276 21.2126 21.2379 23.1067 20.4248Z'
          fill='#FFE266'
        />
        <path
          d='M22.0311 23.8408C22.0311 23.8408 22.7667 26.1585 20.4062 26.8941C20.4062 26.8941 20.5531 24.6181 22.0311 23.8408Z'
          fill='#FFE266'
        />
        <path
          d='M22.0716 22.9453C22.0716 22.9453 22.0117 24.5773 19.4219 24.6253C19.4219 24.6253 20.0251 23.1515 22.0716 22.9453Z'
          fill='#FFE266'
        />
        <path
          d='M19.951 25.8701C19.951 25.8701 19.9617 28.3049 17.4922 28.2806C17.4922 28.2806 18.3103 26.1563 19.951 25.8701Z'
          fill='#FFE266'
        />
        <path
          d='M20.2585 25.0275C20.2585 25.0275 19.7151 26.5647 17.2324 25.8137C17.2324 25.8137 18.2466 24.5947 20.2585 25.0275Z'
          fill='#FFE266'
        />
        <path
          d='M17.8649 27.4513C17.8649 27.4513 17.326 29.824 14.9277 29.226C14.9277 29.226 16.2034 27.3489 17.8649 27.4513Z'
          fill='#FFE266'
        />
        <path
          d='M18.3516 26.7032C18.3516 26.7032 17.4761 28.0733 15.2285 26.7646C15.2285 26.7646 16.491 25.8139 18.3516 26.7032Z'
          fill='#FFE266'
        />
        <path
          d='M14.9508 28.1207C14.9508 28.1207 13.9385 30.3276 11.7148 29.236C11.7148 29.236 13.3467 27.6694 14.9508 28.1207Z'
          fill='#FFE266'
        />
        <path
          d='M15.5813 27.4921C15.5813 27.4921 14.4449 28.6471 12.5137 26.8929C12.5137 26.8929 13.9432 26.2296 15.5813 27.4921Z'
          fill='#FFE266'
        />
        <path
          d='M12.0845 28.2216C12.0845 28.2216 10.6783 30.1936 8.69922 28.6941C8.69922 28.6941 10.5939 27.47 12.0845 28.2216Z'
          fill='#FFE266'
        />
        <path
          d='M12.8219 27.7262C12.8219 27.7262 11.49 28.6417 9.92188 26.5469C9.92188 26.5469 11.4491 26.1704 12.8219 27.7262Z'
          fill='#FFE266'
        />
        <path
          d='M9.28682 27.805C9.28682 27.805 7.36821 29.2648 5.91602 27.2365C5.91602 27.2365 8.08296 26.6379 9.28682 27.805Z'
          fill='#FFE266'
        />
        <path
          d='M10.1363 27.5532C10.1363 27.5532 8.59776 28.0263 7.71094 25.5537C7.71094 25.5537 9.27911 25.6542 10.1363 27.5532Z'
          fill='#FFE266'
        />
        <path
          d='M6.72532 26.4649C6.72532 26.4649 4.46194 27.2665 3.68164 24.8867C3.68164 24.8867 5.92485 24.9828 6.72532 26.4649Z'
          fill='#FFE266'
        />
        <path
          d='M7.60823 26.4858C7.60823 26.4858 6.00036 26.4634 5.89258 23.834C5.89258 23.834 7.35738 24.4121 7.60823 26.4858Z'
          fill='#FFE266'
        />
        <path
          d='M4.70277 24.8148C4.70277 24.8148 2.31585 25.0408 2.12109 22.54C2.12109 22.54 4.27606 23.1803 4.70277 24.8148Z'
          fill='#FFE266'
        />
        <path
          d='M5.55408 25.051C5.55408 25.051 3.99852 24.6375 4.51536 22.0586C4.51536 22.0586 5.80052 22.9773 5.55408 25.051Z'
          fill='#FFE266'
        />
        <path
          d='M3.1618 22.2159C3.1618 22.2159 0.781186 21.933 1.10201 19.4463C1.10201 19.4463 3.07923 20.5276 3.1618 22.2159Z'
          fill='#FFE266'
        />
        <path
          d='M3.94701 22.6266C3.94701 22.6266 2.51058 21.8935 3.54363 19.4805C3.54363 19.4805 4.61323 20.6502 3.94701 22.6266Z'
          fill='#FFE266'
        />
        <path
          d='M2.16341 19.4842C2.16341 19.4842 -0.121401 18.7479 0.658271 16.3682C0.658271 16.3682 2.39788 17.8106 2.16341 19.4842Z'
          fill='#FFE266'
        />
        <path
          d='M2.85924 20.0393C2.85924 20.0393 1.58541 19.0431 3.05021 16.8721C3.05021 16.8721 3.88157 18.2268 2.85924 20.0393Z'
          fill='#FFE266'
        />
        <path
          d='M1.67571 16.6573C1.67571 16.6573 -0.291433 15.266 1.14753 13.2275C1.14753 13.2275 2.38794 15.129 1.67571 16.6573Z'
          fill='#FFE266'
        />
        <path
          d='M2.17722 17.3962C2.17722 17.3962 1.25131 16.0607 3.28401 14.4287C3.28401 14.4287 3.68298 15.973 2.17722 17.3962Z'
          fill='#FFE266'
        />
        <path
          d='M2.12242 13.764C2.12242 13.764 0.662036 11.8331 2.64116 10.333C2.64116 10.333 3.25695 12.5264 2.12242 13.764Z'
          fill='#FFE266'
        />
        <path
          d='M2.38136 14.6217C2.38136 14.6217 1.89667 13.0647 4.32014 12.1338C4.32014 12.1338 4.2401 13.728 2.38136 14.6217Z'
          fill='#FFE266'
        />
      </g>
      <defs>
        <clipPath id='clip0_42435_4605'>
          <rect width='26.2372' height='30.0634' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
